// dummy capability, the code handles both single and multiple prefixes just fine
export var MultiPrefixCapability = {
    name: 'multi-prefix'
};
